export const ID_BUNDLE_ADDITIONAL_SEATS = '62f0f9984b0af607f449f922';
export const ID_BUNDLE_DOMAINS = '62f0f9984b0af607f449f923';
export const ID_BUNDLE_AI_DASHBOARD = '62f0f9984b0af607f449f924';
export const ID_BUNDLE_OFFERS = '62f0f9984b0af607f449f925';

// The BF 2026 copies of the pack add-ons: the same packs at other prices,
// under ids the copies script pins.
export const ID_BUNDLE_PACK_COPY_TO_ID_ORIGINAL: Record<string, string> = {
  '6a1b2710202600000000f922': ID_BUNDLE_ADDITIONAL_SEATS,
  '6a1b2710202600000000f923': ID_BUNDLE_DOMAINS,
  '6a1b2710202600000000f924': ID_BUNDLE_AI_DASHBOARD,
  '6a1b2710202600000000f925': ID_BUNDLE_OFFERS,
};

export const OPTIONS_DURATION_BUNDLE = [
  { value: 1, label: '1 Month' },
  { value: 12, label: '12 Months' },
];
